 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TRIUMPHANDDEFEAT_FRONTCOVER from '@/components/TriumphandDefeat_frontcover'
 import TRIUMPHANDDEFEAT_FM from '@/components/TriumphandDefeat_fm'
 import TRIUMPHANDDEFEAT_TITLE from '@/components/TriumphandDefeat_title'
 import TRIUMPHANDDEFEAT_COPYRIGHTPAGE from '@/components/TriumphandDefeat_copyrightPage'
 import TRIUMPHANDDEFEAT_DEDICATIONPAGE from '@/components/TriumphandDefeat_dedicationPage'
 import TRIUMPHANDDEFEAT_FM1 from '@/components/TriumphandDefeat_fm1'
 import TRIUMPHANDDEFEAT_TOC from '@/components/TriumphandDefeat_toc'
 import TRIUMPHANDDEFEAT_PREFACEANDACKNOWLEDGMENTS from '@/components/TriumphandDefeat_prefaceandacknowledgments'
 import TRIUMPHANDDEFEAT_FOREWORD from '@/components/TriumphandDefeat_foreword'
 import TRIUMPHANDDEFEAT_CH1 from '@/components/TriumphandDefeat_ch1'
 import TRIUMPHANDDEFEAT_CH101 from '@/components/TriumphandDefeat_ch101'
 import TRIUMPHANDDEFEAT_CH102 from '@/components/TriumphandDefeat_ch102'
 import TRIUMPHANDDEFEAT_CH103 from '@/components/TriumphandDefeat_ch103'
 import TRIUMPHANDDEFEAT_CH104 from '@/components/TriumphandDefeat_ch104'
 import TRIUMPHANDDEFEAT_CH105 from '@/components/TriumphandDefeat_ch105'
 import TRIUMPHANDDEFEAT_CH106 from '@/components/TriumphandDefeat_ch106'
 import TRIUMPHANDDEFEAT_CH107 from '@/components/TriumphandDefeat_ch107'
 import TRIUMPHANDDEFEAT_CH108 from '@/components/TriumphandDefeat_ch108'
 import TRIUMPHANDDEFEAT_CH109 from '@/components/TriumphandDefeat_ch109'
 import TRIUMPHANDDEFEAT_CH2 from '@/components/TriumphandDefeat_ch2'
 import TRIUMPHANDDEFEAT_CH201 from '@/components/TriumphandDefeat_ch201'
 import TRIUMPHANDDEFEAT_CH202 from '@/components/TriumphandDefeat_ch202'
 import TRIUMPHANDDEFEAT_CH203 from '@/components/TriumphandDefeat_ch203'
 import TRIUMPHANDDEFEAT_CH204 from '@/components/TriumphandDefeat_ch204'
 import TRIUMPHANDDEFEAT_CH205 from '@/components/TriumphandDefeat_ch205'
 import TRIUMPHANDDEFEAT_CH206 from '@/components/TriumphandDefeat_ch206'
 import TRIUMPHANDDEFEAT_CH207 from '@/components/TriumphandDefeat_ch207'
 import TRIUMPHANDDEFEAT_CH208 from '@/components/TriumphandDefeat_ch208'
 import TRIUMPHANDDEFEAT_CH209 from '@/components/TriumphandDefeat_ch209'
 import TRIUMPHANDDEFEAT_CH210 from '@/components/TriumphandDefeat_ch210'
 import TRIUMPHANDDEFEAT_CH211 from '@/components/TriumphandDefeat_ch211'
 import TRIUMPHANDDEFEAT_CH212 from '@/components/TriumphandDefeat_ch212'
 import TRIUMPHANDDEFEAT_CH3 from '@/components/TriumphandDefeat_ch3'
 import TRIUMPHANDDEFEAT_CH301 from '@/components/TriumphandDefeat_ch301'
 import TRIUMPHANDDEFEAT_CH302 from '@/components/TriumphandDefeat_ch302'
 import TRIUMPHANDDEFEAT_CH303 from '@/components/TriumphandDefeat_ch303'
 import TRIUMPHANDDEFEAT_CH304 from '@/components/TriumphandDefeat_ch304'
 import TRIUMPHANDDEFEAT_CH4 from '@/components/TriumphandDefeat_ch4'
 import TRIUMPHANDDEFEAT_CH401 from '@/components/TriumphandDefeat_ch401'
 import TRIUMPHANDDEFEAT_CH402 from '@/components/TriumphandDefeat_ch402'
 import TRIUMPHANDDEFEAT_CH5 from '@/components/TriumphandDefeat_ch5'
 import TRIUMPHANDDEFEAT_CH501 from '@/components/TriumphandDefeat_ch501'
 import TRIUMPHANDDEFEAT_CH502 from '@/components/TriumphandDefeat_ch502'
 import TRIUMPHANDDEFEAT_CH503 from '@/components/TriumphandDefeat_ch503'
 import TRIUMPHANDDEFEAT_CH504 from '@/components/TriumphandDefeat_ch504'
 import TRIUMPHANDDEFEAT_CH505 from '@/components/TriumphandDefeat_ch505'
 import TRIUMPHANDDEFEAT_CH506 from '@/components/TriumphandDefeat_ch506'
 import TRIUMPHANDDEFEAT_CH6 from '@/components/TriumphandDefeat_ch6'
 import TRIUMPHANDDEFEAT_CH601 from '@/components/TriumphandDefeat_ch601'
 import TRIUMPHANDDEFEAT_CH602 from '@/components/TriumphandDefeat_ch602'
 import TRIUMPHANDDEFEAT_CH603 from '@/components/TriumphandDefeat_ch603'
 import TRIUMPHANDDEFEAT_CH604 from '@/components/TriumphandDefeat_ch604'
 import TRIUMPHANDDEFEAT_CH605 from '@/components/TriumphandDefeat_ch605'
 import TRIUMPHANDDEFEAT_CH606 from '@/components/TriumphandDefeat_ch606'
 import TRIUMPHANDDEFEAT_CH7 from '@/components/TriumphandDefeat_ch7'
 import TRIUMPHANDDEFEAT_CH701 from '@/components/TriumphandDefeat_ch701'
 import TRIUMPHANDDEFEAT_CH702 from '@/components/TriumphandDefeat_ch702'
 import TRIUMPHANDDEFEAT_CH703 from '@/components/TriumphandDefeat_ch703'
 import TRIUMPHANDDEFEAT_CH704 from '@/components/TriumphandDefeat_ch704'
 import TRIUMPHANDDEFEAT_CH705 from '@/components/TriumphandDefeat_ch705'
 import TRIUMPHANDDEFEAT_CH706 from '@/components/TriumphandDefeat_ch706'
 import TRIUMPHANDDEFEAT_CH8 from '@/components/TriumphandDefeat_ch8'
 import TRIUMPHANDDEFEAT_CH801 from '@/components/TriumphandDefeat_ch801'
 import TRIUMPHANDDEFEAT_CH802 from '@/components/TriumphandDefeat_ch802'
 import TRIUMPHANDDEFEAT_CH803 from '@/components/TriumphandDefeat_ch803'
 import TRIUMPHANDDEFEAT_CH804 from '@/components/TriumphandDefeat_ch804'
 import TRIUMPHANDDEFEAT_CH805 from '@/components/TriumphandDefeat_ch805'
 import TRIUMPHANDDEFEAT_CH806 from '@/components/TriumphandDefeat_ch806'
 import TRIUMPHANDDEFEAT_CH807 from '@/components/TriumphandDefeat_ch807'
 import TRIUMPHANDDEFEAT_CH9 from '@/components/TriumphandDefeat_ch9'
 import TRIUMPHANDDEFEAT_CH901 from '@/components/TriumphandDefeat_ch901'
 import TRIUMPHANDDEFEAT_CH902 from '@/components/TriumphandDefeat_ch902'
 import TRIUMPHANDDEFEAT_CH903 from '@/components/TriumphandDefeat_ch903'
 import TRIUMPHANDDEFEAT_CH904 from '@/components/TriumphandDefeat_ch904'
 import TRIUMPHANDDEFEAT_CH10 from '@/components/TriumphandDefeat_ch10'
 import TRIUMPHANDDEFEAT_CH1001 from '@/components/TriumphandDefeat_ch1001'
 import TRIUMPHANDDEFEAT_CH1002 from '@/components/TriumphandDefeat_ch1002'
 import TRIUMPHANDDEFEAT_CH1003 from '@/components/TriumphandDefeat_ch1003'
 import TRIUMPHANDDEFEAT_CH1004 from '@/components/TriumphandDefeat_ch1004'
 import TRIUMPHANDDEFEAT_CH1005 from '@/components/TriumphandDefeat_ch1005'
 import TRIUMPHANDDEFEAT_CH1006 from '@/components/TriumphandDefeat_ch1006'
 import TRIUMPHANDDEFEAT_EPILOGUE from '@/components/TriumphandDefeat_epilogue'
 import TRIUMPHANDDEFEAT_EPILOGUE01 from '@/components/TriumphandDefeat_epilogue01'
 import TRIUMPHANDDEFEAT_EPILOGUE02 from '@/components/TriumphandDefeat_epilogue02'
 import TRIUMPHANDDEFEAT_NOTES from '@/components/TriumphandDefeat_notes'
 import TRIUMPHANDDEFEAT_BIBLIOGRAPHY from '@/components/TriumphandDefeat_bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/TriumphandDefeat_frontcover",
 			"name" : "TriumphandDefeat_frontcover",
 			"component" : TRIUMPHANDDEFEAT_FRONTCOVER
 		},
 		{
 			"path" : "/TriumphandDefeat_fm",
 			"name" : "TriumphandDefeat_fm",
 			"component" : TRIUMPHANDDEFEAT_FM
 		},
 		{
 			"path" : "/TriumphandDefeat_title",
 			"name" : "TriumphandDefeat_title",
 			"component" : TRIUMPHANDDEFEAT_TITLE
 		},
 		{
 			"path" : "/TriumphandDefeat_copyrightPage",
 			"name" : "TriumphandDefeat_copyrightPage",
 			"component" : TRIUMPHANDDEFEAT_COPYRIGHTPAGE
 		},
 		{
 			"path" : "/TriumphandDefeat_dedicationPage",
 			"name" : "TriumphandDefeat_dedicationPage",
 			"component" : TRIUMPHANDDEFEAT_DEDICATIONPAGE
 		},
 		{
 			"path" : "/TriumphandDefeat_fm1",
 			"name" : "TriumphandDefeat_fm1",
 			"component" : TRIUMPHANDDEFEAT_FM1
 		},
 		{
 			"path" : "/TriumphandDefeat_toc",
 			"name" : "TriumphandDefeat_toc",
 			"component" : TRIUMPHANDDEFEAT_TOC
 		},
 		{
 			"path" : "/TriumphandDefeat_prefaceandacknowledgments",
 			"name" : "TriumphandDefeat_prefaceandacknowledgments",
 			"component" : TRIUMPHANDDEFEAT_PREFACEANDACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/TriumphandDefeat_foreword",
 			"name" : "TriumphandDefeat_foreword",
 			"component" : TRIUMPHANDDEFEAT_FOREWORD
 		},
 		{
 			"path" : "/TriumphandDefeat_ch1",
 			"name" : "TriumphandDefeat_ch1",
 			"component" : TRIUMPHANDDEFEAT_CH1
 		},
 		{
 			"path" : "/TriumphandDefeat_ch101",
 			"name" : "TriumphandDefeat_ch101",
 			"component" : TRIUMPHANDDEFEAT_CH101
 		},
 		{
 			"path" : "/TriumphandDefeat_ch102",
 			"name" : "TriumphandDefeat_ch102",
 			"component" : TRIUMPHANDDEFEAT_CH102
 		},
 		{
 			"path" : "/TriumphandDefeat_ch103",
 			"name" : "TriumphandDefeat_ch103",
 			"component" : TRIUMPHANDDEFEAT_CH103
 		},
 		{
 			"path" : "/TriumphandDefeat_ch104",
 			"name" : "TriumphandDefeat_ch104",
 			"component" : TRIUMPHANDDEFEAT_CH104
 		},
 		{
 			"path" : "/TriumphandDefeat_ch105",
 			"name" : "TriumphandDefeat_ch105",
 			"component" : TRIUMPHANDDEFEAT_CH105
 		},
 		{
 			"path" : "/TriumphandDefeat_ch106",
 			"name" : "TriumphandDefeat_ch106",
 			"component" : TRIUMPHANDDEFEAT_CH106
 		},
 		{
 			"path" : "/TriumphandDefeat_ch107",
 			"name" : "TriumphandDefeat_ch107",
 			"component" : TRIUMPHANDDEFEAT_CH107
 		},
 		{
 			"path" : "/TriumphandDefeat_ch108",
 			"name" : "TriumphandDefeat_ch108",
 			"component" : TRIUMPHANDDEFEAT_CH108
 		},
 		{
 			"path" : "/TriumphandDefeat_ch109",
 			"name" : "TriumphandDefeat_ch109",
 			"component" : TRIUMPHANDDEFEAT_CH109
 		},
 		{
 			"path" : "/TriumphandDefeat_ch2",
 			"name" : "TriumphandDefeat_ch2",
 			"component" : TRIUMPHANDDEFEAT_CH2
 		},
 		{
 			"path" : "/TriumphandDefeat_ch201",
 			"name" : "TriumphandDefeat_ch201",
 			"component" : TRIUMPHANDDEFEAT_CH201
 		},
 		{
 			"path" : "/TriumphandDefeat_ch202",
 			"name" : "TriumphandDefeat_ch202",
 			"component" : TRIUMPHANDDEFEAT_CH202
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js